import React from "react";
import { Link } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";

import { CATEGORIES, isExternal, isUpcoming } from "./workshopUtils";
import "./MegaMenu.less";

// Entries whose url is a full https:// address (the BRICS hackathon lives on
// IUCAA's site) open in a new tab; everything else routes internally.
function PanelLink({ to, className, onNavigate, children }) {
  if (!to) return <span className={className}>{children}</span>;

  if (isExternal(to)) {
    return (
      <a
        className={className}
        href={to}
        target="_blank"
        rel="noreferrer noopener"
        onClick={onNavigate}
      >
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={to} onClick={onNavigate}>
      {children}
    </Link>
  );
}

export default function MegaMenu({ groups, onNavigate }) {
  return (
    <div className="mega-menu">
      {CATEGORIES.map(({ key, label }, index) => {
        const group = groups[key] || { visible: [], hasArchive: false, hasUpcoming: false };

        return (
          <div className="mega-menu-col" key={key} style={{ "--i": index }}>
            <div className="mega-menu-heading">
              {label}
              {group.hasUpcoming && (
                <span className="mega-menu-badge">NEW</span>
              )}
            </div>

            {group.visible.length ? (
              <ul className="mega-menu-list">
                {group.visible.map((item) => (
                  <li key={item.id}>
                    <PanelLink
                      to={item.url}
                      className="mega-menu-link"
                      onNavigate={onNavigate}
                    >
                      <span className="mega-menu-link-text">{item.title}</span>
                      {isUpcoming(item) && (
                        <span className="mega-menu-badge">NEW</span>
                      )}
                    </PanelLink>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="mega-menu-empty">Coming soon</div>
            )}

            {group.hasArchive && (
              <PanelLink
                to={`/workshop-archive?category=${key}`}
                className="mega-menu-archive"
                onNavigate={onNavigate}
              >
                Past editions archive
                <RightOutlined />
              </PanelLink>
            )}
          </div>
        );
      })}
    </div>
  );
}
